export type APIData = {
  global: any;
  controller: string;
  action: string;
  body: any;
};

export function generateState(initial: APIData) {
  const state = {
    ...initial.global,
  };
  if (!state[initial.controller]) {
    state[initial.controller] = {};
  }
  state[initial.controller][initial.action] = initial.body;
  return state;
}



// WEBPACK FOOTER //
// ./frontend/src/common/utils/generateStateFromAPIData.ts